(function(){
     'use strict';

     angular
        .module('appback')
        .factory('CodigosService', CodigosService);

    CodigosService.$inject = ['$http'];

    function CodigosService($http){


        var service= {
           getCodigosInit:getCodigosInit,
           getCodigoAnalitica:getCodigoAnalitica
        };

        return service;
        function getCodigosInit(grupo_id,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/codigos/getcodigosinit', { params : { grupo_id:grupo_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function getCodigoAnalitica(analitica,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getcodigoanalitica', { params : { analitica_id : analitica.id, codigo:analitica.codigo } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }



    }
})();